const translations = {
  "en": {
    "Build a list to track the stocks and tokens that matter to you.": "Build a list to track the stocks and tokens that matter to you.",
    "Create Portfolio": "Create Portfolio",
    "Edit Portfolio": "Edit Portfolio",
    "Give it a name to keep it organized.": "Give it a name to keep it organized.",
    "Portfolio Name": "Portfolio Name",
    "Save": "Save"
  },
  "zh-tw": {
    "Build a list to track the stocks and tokens that matter to you.": "建立一個清單來追蹤你關注的股票和代幣。",
    "Create Portfolio": "建立投資組合",
    "Edit Portfolio": "編輯投資組合",
    "Give it a name to keep it organized.": "給它取個名稱以保持整齊有序。",
    "Portfolio Name": "投資組合名稱",
    "Save": "儲存"
  }
};

export default translations;
